export default {
    completa: "Completa el pago de tu suscripción",
    forma: "Forma de pago",
    tbk: "Transbank",
    tbkDesc: "Pagar usando Transbank",
    dLocal: "dLocal Go",
    dLocalDesc: "Pagar usando tarjetas o efectivo con dLocal Go",
    handy: "Tarjeta de crédito internacional",
    handyDesc: "Pagar usando tarjeta de crédito internacional",
    auto: "Suscripción con renovación automática",
    stripe: "Stripe",
    stripeDesc: "Pagar usando Stripe",
    resumen: "Resumen de tu suscripción",
    diferencia: "Te cobraremos la diferencia para cambiar tu plan a: ",
    frecuencia: "Frecuencia de cobro: ",
    5: "(ahorra un 5%)",
    10: "(ahorra un 10%)",
    ingresarCupon: "Ingresar cupón de descuento",
    cupon: "Cupón de descuento",
    total: "Total",
    acuerdo: "Al confirmar estoy de acuerdo con los",
    terminos: "Términos de uso",
    msgSeleccionarMetodo: "Selecciona una forma de pago para continuar",
    errorCupon: "Cupón inválido",
    mensual: "Mensual",
    semestral: "Semestral",
    anual: "Anual",
    dtoAplicado: "Descuento aplicado",
    elige: "Elige el plan más adecuado para ti",
    mes: "/mes",
    meses: "/6 meses",
    año: "/año",
    incluye: "Incluye: ",
    hasta: "Hasta ",
    usuarios: " usuarios",
    clientes: " clientes",
    ordenes: " órdenes",
    sucursales: " sucursales",
    serv: "Servicios en terreno",
    graficos: "Gráficos estadísticos",
    appTecnico: "APP Android e iOS para el técnico",
    appCliente: "APP Android para clientes",
    web: "Web Reclamos Clientes",
    wpp: "Whatsapp",
    api: "API",
    soporte: "Tiempo respuesta de soporte",
    contratarPremium: "Para contratar el plan Premium debe ponerse en contacto con nosotros",
    txtSubirPlan: "Para usar esta función, sube de plan",
    btnSubirPlan: "Subir de plan",
}